export const CONFIRMATION_DIALOG = {
  CLOSE_BUTTON: 'confirmation-dialog-close-button',
  DONT_SHOW_AGAIN_CHECKBOX: 'confirmation-dialog-dont-show-again-checkbox',
  DONT_SHOW_AGAIN_LABEL: 'confirmation-dialog-dont-show-again-label',
  DIALOG_CONTAINER: 'confirmation-dialog-container'
} as const;
